<app-chips
  class="sport-filter"
  [buttonText]="filterLabel"
  [dialogTitle]="'attende.sport_filter.button.label' | translate"
  [hasSelectedState]="this.selectedSportGroup"
  (clear)="updateSelectedSportGroup(null)"
>
  <ul *ngIf="sportGroupCollection?.length > 0" class="sport-filter__list">
    <li *ngFor="let sportGroup of sportGroupCollection">
      <app-horizontal-card
        [title]="sportGroup?.title | translate"
        [description]="sportGroup?.description | translate"
        [image]="sportGroup?.image"
        [dataEmitClick]="sportGroup"
        (clicked)="updateSelectedSportGroup($event)"
      ></app-horizontal-card>
    </li>
  </ul>
</app-chips>
